import { createFileRoute } from "@tanstack/react-router";

import { AgentModesList } from "@/features/agent-modes";

/**
 * ``/settings/modes`` — Agent Modes list. Mounted under the modal shell
 * since May 24, 2026 (moved from `_authed/settings/modes.tsx`).
 */
export const Route = createFileRoute("/_authed/_modal/settings/modes")({
  component: AgentModesList,
});
